import React from 'react';
import EmployeeFinanceTab from './EmployeeFinanceTab';

const EmployeeFinancePage = () => {
  return (
    <div className="max-w-7xl mx-auto p-6 animate-fade-in pb-20">
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-800">Finance</h1>
        <p className="text-slate-500">Manage your assets, expenses, reimbursements, procurements, and pending approvals.</p>
      </div>
      <EmployeeFinanceTab />
    </div>
  );
};

export default EmployeeFinancePage;
